import type { ConnectionCategoryId, ConnectionCategoryMeta } from './types';

export const CONNECTION_CATEGORIES: ConnectionCategoryMeta[] = [
  {
    id: 'databases',
    label: 'Databases',
    description: 'SQL, NoSQL, warehouses, and search indexes for grounding and analytics',
  },
  {
    id: 'cloud_storage',
    label: 'Cloud Storage',
    description: 'Object and drive storage for documents and file RAG',
  },
  {
    id: 'file_transfer',
    label: 'File Transfer',
    description: 'SFTP/FTP and batch file ingest endpoints',
  },
  {
    id: 'messaging',
    label: 'Messaging & Chat',
    description: 'Agent channels and notifications (Teams, Slack, WhatsApp, …)',
  },
  {
    id: 'email',
    label: 'Email / Mail Servers',
    description: 'SMTP, IMAP, Outlook, and mailbox integrations',
  },
  {
    id: 'collaboration',
    label: 'Collaboration & Knowledge',
    description: 'SharePoint, Workspace, Notion, and knowledge hubs',
  },
  {
    id: 'crm_erp',
    label: 'CRM & Business Apps',
    description: 'Salesforce, Dynamics, HubSpot, and ERP systems',
  },
  {
    id: 'social',
    label: 'Social Platforms',
    description: 'Facebook, Instagram, LinkedIn, and social inboxes',
  },
  {
    id: 'voice_telephony',
    label: 'Voice & Telephony',
    description: 'Twilio and contact-center voice channels',
  },
  {
    id: 'apis',
    label: 'APIs & Webhooks',
    description: 'REST, GraphQL, and inbound webhook endpoints',
  },
  {
    id: 'ai_services',
    label: 'AI / LLM Providers',
    description: 'Model provider credentials and endpoints',
  },
  {
    id: 'identity',
    label: 'Identity & Directory',
    description: 'Entra ID, Okta, and directory context',
  },
  {
    id: 'observability',
    label: 'Observability',
    description: 'Logs, metrics, and ops tooling for agents',
  },
  {
    id: 'payments',
    label: 'Payments',
    description: 'Payment processors for transaction agents',
  },
];

export const CATEGORY_BY_ID: Record<ConnectionCategoryId, ConnectionCategoryMeta> =
  CONNECTION_CATEGORIES.reduce((acc, cat) => {
    acc[cat.id] = cat;
    return acc;
  }, {} as Record<ConnectionCategoryId, ConnectionCategoryMeta>);
